/**
 * A processor that simply passes the data through without any changes.
 * @param rawData - The raw data to be processed.
 * @param setProcessedDataFn - A function to set the processed data.
 */
const passThroughProcessor = (rawData, setProcessedDataFn) => {
    setProcessedDataFn(rawData);
};

/**
 * This processor will apply any safe value conversion as defined by the configuration.
 * @param rawData - The raw data to be processed.
 * @param configuration - The configuration defining safe value conversions.
 * @param setProcessedDataFn - A function to set the processed data.
 */
const safeValueProcessor = (rawData, configuration, setProcessedDataFn) => {
    const watchedProperties = new Set();
    configuration.forEach(fieldConfig => {
        if (fieldConfig.options && fieldConfig.options.safeValuesAlt) {
            watchedProperties.add(fieldConfig.valueProperty);
        }
    });

    // Apply safe value conversions where applicable
    const processedData = {};
    Object.entries(rawData).forEach(([key, value]) => {
        if (watchedProperties.has(key)) {
            const fieldConfig = configuration.find(fc => fc.valueProperty === key);
            const safeValuesAlt = fieldConfig.options.safeValuesAlt;

            // check if the value exists in safeValuesAlt, under valueToConvert key. If so, convert it, otherwise, keep original value.
            let safeValueEntry = value;
            safeValuesAlt.forEach(alt => {
                if (alt.valueToConvert === value) safeValueEntry = alt.valueToConvertTo;
            });
            processedData[key] = safeValueEntry;
        } else {
            processedData[key] = value;
        }

    });

    // turn nulls to empty strings
    Object.entries(processedData).forEach(([key, value]) => {
        if (value === null) processedData[key] = "";
    });

    setProcessedDataFn(processedData);
};

export const variantRawDataProcessorMapCreateEditDialog = {
    defValue: safeValueProcessor,
    userList: safeValueProcessor,
    customerUser: safeValueProcessor,
};